import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgPrimaryLight, space6, space8 } = theme();

  const styles = StyleSheet.create({
    content: {
      flexDirection: "row",
      justifyContent: "center",
      marginBottom: space8,
    },
    title: {
      marginBottom: space6,
    },
  });

  return {
    ...styles,
    containerUnderlayColor: colorBgPrimaryLight,
  };
};

export { style };
